var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.isChecked,"labels":true,"sync":true},on:{"change":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }